/**
 * Logger utility for frontend application.
 * Handles logging based on environment (development/production).
 */

const LOG_LEVELS = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
};

// In production, only show errors. In development, show everything.
const CURRENT_LOG_LEVEL =
  process.env.NODE_ENV === "production" ? LOG_LEVELS.ERROR : LOG_LEVELS.DEBUG;

const logger = {
  debug: (...args) => {
    if (CURRENT_LOG_LEVEL <= LOG_LEVELS.DEBUG) {
      // Use refined styling for debug logs in dev
      console.debug(
        "%c[DEBUG]",
        "color: #8f8f8f; font-weight: bold;",
        ...args
      );
    }
  },
  info: (...args) => {
    if (CURRENT_LOG_LEVEL <= LOG_LEVELS.INFO) {
      console.info(
        "%c[INFO]",
        "color: #3498db; font-weight: bold;",
        ...args
      );
    }
  },
  warn: (...args) => {
    if (CURRENT_LOG_LEVEL <= LOG_LEVELS.WARN) {
      console.warn(
        "%c[WARN]",
        "color: #f39c12; font-weight: bold;",
        ...args
      );
    }
  },
  error: (...args) => {
    if (CURRENT_LOG_LEVEL <= LOG_LEVELS.ERROR) {
      console.error(
        "%c[ERROR]",
        "color: #e74c3c; font-weight: bold;",
        ...args
      );
    }
  },
};

export default logger;
